import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timer-wrapper h-10 flex gap-x-3 w-full justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, ":", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, ":", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.hours.h), 1),
    _hoisted_2,
    _createElementVNode("div", null, _toDisplayString(_ctx.min.m), 1),
    _hoisted_3,
    _createElementVNode("div", null, _toDisplayString(_ctx.sec.s), 1)
  ]))
}